import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-year-input',
  templateUrl: './year-input.component.html',
  styleUrls: ['./year-input.component.scss']
})
export class YearInputComponent implements OnInit {

  @Input('value')
  value: number;

  @Output('valueChange')
  valueChange: EventEmitter<number> = new EventEmitter<number>();

  @Input('disabled')
  disabled: boolean;

  constructor() { }

  ngOnInit(): void {
  }

  onValueChange() {
    this.valueChange.emit(this.value)
  }

}
